import { Controller } from "@hotwired/stimulus"
import WaveSurfer from "wavesurfer"

// Connects to data-controller="wavesurfer"
export default class extends Controller {
  static values = { url: String }
  static targets = ['container', 'playButton', 'pauseButton']


  connect() {
    this.wavesurfer = WaveSurfer.create({
      container: this.containerTarget,
      waveColor: 'rgb(200, 0, 200)',
      progressColor: '#007bff',
      cursorColor: '#4f46e5',
      height: 64,
      barWidth: 1,
      barGap: 1,
      barRadius: 2,
      responsive: true,
    })
    console.log('Wavesurfer connected', this.urlValue)

    this.wavesurfer.load(this.urlValue)
  }
  play() {
    if (this.wavesurfer.isPlaying()) {
      this.playButtonTarget.classList.remove('hidden')
      this.pauseButtonTarget.classList.add('hidden')
      this.wavesurfer.pause()
    } else {
      this.playButtonTarget.classList.add('hidden')
      this.pauseButtonTarget.classList.remove('hidden')
      this.wavesurfer.play()
    }
  }

  disconnect() {
    this.wavesurfer.destroy()
  }
}
